export const subrightColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "title", headerName: "Title", flex: 1 },
  // { field: "rightId", headerName: "Right ID", width: 150 },
];
